import React from 'react';
import { TextField } from '@gerdau/hefesto/TextField';

interface IIsManagerFabricationContractInputProps {
  title: string;
  loading: boolean;
  contractError: boolean;
  contractNumber: string;
  setContractNumber(contractNumber: string): void;
  customerOrder?: string;
  helperText?: string;
}

const IsManagerFabricationContractInput: React.FC<
  IIsManagerFabricationContractInputProps
> = ({
  title,
  loading,
  contractError,
  contractNumber,
  setContractNumber,
  customerOrder,
  helperText
}) => {
  return (
    <TextField
      label={title}
      name="contractManagerInput"
      placeholder="Digite o número do contrato"
      disabled={loading}
      variant={contractError && !loading ? 'danger' : undefined}
      supportMessage={
        contractError && !loading ? 'Contrato não encontrado.' : customerOrder
      }
      value={contractNumber || ''}
      onChange={(e) => setContractNumber(e.target.value)}
      helperText={helperText}
    />
  );
};

export default IsManagerFabricationContractInput;
